import React from 'react';
import { Field } from 'react-final-form';
import FormDateTimePicker from 'Shared/components/FormComponents/FormDateTimePicker';

import Collapsed from '../Collapsed';

export default function DateFilter() {
  return (
    <div className="d-flex flex-column">
      <Collapsed title="Assigned at">
        <div className="d-flex flex-column">
          <Field
            name="startDate"
            placeholder="Start"
            timeFormat={false}
            component={FormDateTimePicker}
            inputClassName="mb-2"
          />
          <Field name="endDate" placeholder="End" timeFormat={false} component={FormDateTimePicker} className="mb-2" />
        </div>
      </Collapsed>
    </div>
  );
}
